import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouthouston() {
  return (
    <section className="about_houston tekrevol_dark_bg max_miami p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Your Gateway to High-End Mobile App Development in Dallas</h2>
            <p>
              From startups to established enterprises, TekRevol empowers
              businesses of all sizes to thrive efficiently. Our Dallas-based
              mobile app developers leverage cutting-edge technologies and
              streamlined processes to deliver tailored, high-performing
              solutions. Integrate a robust user interface into your business
              ecosystem and unlock new growth avenues with improved engagement,
              immersive experiences, and enhanced returns on investment. Whether
              your target audience is on Android or iOS platforms, our custom
              mobile app development services in Dallas are designed to adapt
              seamlessly to your business objectives.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-lg-auto mt-md-0"
          >
            <div className="maximize_miami_img">
              <StaticImage
                src="../../images/location_new/dallas/gateway_dallas.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={907}
                height={841}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouthouston;
